import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Container = styled(Box)(({ theme }) => ({
  position: 'absolute',
  zIndex: 2,
  display: 'flex',
  flexDirection: 'column',

  background: theme.palette.common.white,
  borderRadius: '1rem',
  padding: '1.5rem',
  boxShadow: '0 1px 100px 0 rgba(14, 119, 218, 0.15)',

  top: '28%',
  left: '50%',
  transform: 'translateX(-50%)',

  width: '95%',
  maxWidth: '32rem',
  minWidth: 'unset',

  [theme.breakpoints.up('md')]: {
    top: '11%',
    left: '55%',
    transform: 'none',

    width: '35%',
    maxWidth: '32rem',
    minWidth: '24rem',
  },
}));

export const CheckboxWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '0.75rem',
}));
